import script from "./AdminHomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminHomePage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminHomePage.vue?vue&type=style&index=0&id=9bd93fda&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bd93fda"]])

export default __exports__